var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./CommonMap.jinja');
require('./CommonMap.less');


var defaultOptions = {
    theme: 'light',
    legendPosition: 'center'
};

module.exports = Base.extend({

    template: template,


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'initMap');

        this.options.map = _.extend({}, defaultOptions, JSON.parse(this.$el.attr('data-map')));

        this.MAP_CENTER = this.options.map.location.latlng;
        this.MAP_COMPANY = this.options.map.location.latlng;

        /*eslint-disable */
        var address = this.$('.CommonMap-mapBoxAddress p').length ? this.$('.CommonMap-mapBoxAddress p').eq(0).text() : this.$('.CommonMap-mapBoxAddress').text();
        /*eslint-enable */

        var gmapsUrl = 'https://www.google.com/maps/place/' + encodeURIComponent(address) + '/@' + this.options.map.location.latlng.lat + ',' + this.options.map.location.latlng.lng + ',15z';
        this.$('.CommonMap-mapBox').attr('href', gmapsUrl);

        Base.prototype.initialize.call(this, options);
    },


    viewsRegistration: function () {
        Base.prototype.viewsRegistration.call(this);

        //cause of asynk js lib loading
        if (window.app.state.googleMapsAPIReady) {
            this.initMap();
        } else {
            window.app.vent.on('google-maps-ready', this.initMap);
        }
    },


    initMap: function () {
        var styles = {
            'light': [
                {
                    'stylers': [
                        {'hue': '#ff1a00'},
                        {'invert_lightness': false},
                        {'saturation': -100},
                        {'lightness': 33},
                        {'gamma': 0.5}
                    ]
                },
                {
                    'featureType': 'water',
                    'elementType': 'geometry',
                    'stylers': [{'color': '#c9c9c9'}]
                }
            ],
            'dark': [
                {
                    'stylers': [
                        {'hue': '#ff1a00'},
                        {'invert_lightness': true},
                        {'saturation': -100},
                        {'lightness': 33},
                        {'gamma': 0.5}
                    ]
                },
                {
                    'featureType': 'water',
                    'elementType': 'geometry',
                    'stylers': [{'color': '#2D333C'}]
                }
            ]
        };


        var latlng = new google.maps.LatLng(this.MAP_CENTER.lat, this.MAP_CENTER.lng);
        var settings = {
            zoom: 15,
            center: latlng,
            mapTypeControlOptions: {style: google.maps.MapTypeControlStyle.DROPDOWN_MENU},
            navigationControl: false,
            mapTypeControl: false,
            zoomControl: false,
            scrollwheel: false,
            streetViewControl: false,
            navigationControlOptions: {style: google.maps.NavigationControlStyle.SMALL},
            mapTypeId: google.maps.MapTypeId.ROADMAP
        };

        this.map = new google.maps.Map(this.$('.CommonMap-mapWrapper')[0], settings);
        this.map.setOptions({styles: styles[this.options.map.theme]});

        var companyLogo = new google.maps.MarkerImage(
            '/static/svg/front/location.svg',
            new google.maps.Size(44,64),
            new google.maps.Point(0,0),
            new google.maps.Point(22,64),
            new google.maps.Size(44, 64)
        );
        var companyPos = new google.maps.LatLng(this.MAP_COMPANY.lat, this.MAP_COMPANY.lng);
        var companyMarker = new google.maps.Marker({
            position: companyPos,
            map: this.map,
            icon: companyLogo
        });

        this.directionsService = new google.maps.DirectionsService();

        this.directionsDisplay = new google.maps.DirectionsRenderer({
            preserveViewport: true,
            markerOptions: {visible: false},
            polylineOptions: {strokeColor: '#fe8c8b', strokeWeight: 4}
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/CommonMap/CommonMap.js
// module id = 65
// module chunks = 0